import BaseComponent from 'foundation/base-component';
import app from 'general/js/app';
import { spaLoad } from 'components/spa-load';
import gtm from '../../../general/js/gtm';

export default class LiveSubmenu extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    static getRequiredRefs() {
        return [
            'link'
        ];
    }

    init() {
        this.checkIfItemIsSelected();

        this.refs.link.forEach((link) => {
            this.addListener(link, 'click', this.onLinkClick);
            this.addListener(link, 'click', this.saveActionToGtm);
        });

        this.adjustSubmenuPadding = this.adjustSubmenuPadding.bind(this);

        if ('visualViewport' in window) {
            this.adjustSubmenuPadding();
            window.visualViewport.addEventListener('resize', this.adjustSubmenuPadding);
            window.visualViewport.addEventListener('scroll', this.adjustSubmenuPadding);
            window.addEventListener('orientationchange', this.adjustSubmenuPadding);
        }
    }


    saveActionToGtm = (event) => {
        const clickedItem = event.target;
        const itemText = clickedItem.innerText || clickedItem.textContent;
        gtm.push('Top Ribbon', 'Click', itemText);
    }

    checkIfItemIsSelected = () => {
        this.clearSelection(this.refs.link);

        this.refs.link.forEach((link) => {
            if (link.getAttribute('href') === window.location.pathname) {
                window.scrollTo(0, 0);
                link.classList.add('is-active');
            } else if (this.getAttribute(link, 'aliases')) {
                const aliases = JSON.parse(this.getAttribute(link, 'aliases'));
                if (aliases.includes(window.location.pathname)) {
                    link.classList.add('is-active');
                }
            }
        });
    };

    clearSelection(nodesArray) {
        nodesArray.forEach((node) => {
            if (node.classList.contains('is-active')) {
                node.classList.remove('is-active');
            }
        });
    }

    onLinkClick = (event) => {
        if (app.isEditMode) return;

        const ignoreSpa = event.currentTarget.getAttribute('data-ignore-spa') === 'true';

        if (!ignoreSpa) {
            event.preventDefault();
            spaLoad.updateContent(event.target.getAttribute('href'));
            this.checkIfItemIsSelected();
        }
    };

    adjustSubmenuPadding() {
        const element = this.el;
        if (!element || !window.visualViewport) return;

        const safeBottom = window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop;

        const safeValue = Math.max(safeBottom, 0);

        element.style.setProperty('--safe-bottom', `${safeValue}px`);
    }
}
